import React from 'react';
import axios from 'axios';
import { Button, Form, Grid, Icon, Input, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ReactExport from 'react-data-export';
import { toast, ToastContainer } from 'react-toastify';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class ExamApplicationsByProfessor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputDocNum: false,

            semesterOptions: [],
            professorOptions: [],
            courseOptions: [],

            academicYear: null,
            semesters: [],
            professor: null,
            courses: [],
            fromDate: null,
            toDate: null,

            exams: [],
            filteredExams: [],
            loadingExams: false,
            selectedExams: [],
            language: 'ba',
            languages: [
                {
                    text: 'B/H/S',
                    key: 'ba',
                    value: 'ba'
                },
                {
                    text: 'Engleski',
                    key: 'en',
                    value: 'en'
                }
            ],
            orientation: 'horizontal',
            orientations: [
                {
                    text: 'Horizontalno',
                    key: 'horizontal',
                    value: 'horizontal'
                },
                {
                    text: 'Vertikalno',
                    key: 'vertical',
                    value: 'vertical'
                }
            ],
        };
    }

    componentDidMount() {
        const savedFilters = localStorage.getItem('examApplicationsByProfessorFilters');
        if (savedFilters) {
            const parsedFilters = JSON.parse(savedFilters);
            this.setState({
                ...parsedFilters
            }, () => {
                if (this.state.courses && this.state.courses.length > 0) {
                    this.fetchExams();
                }
            });
        } else {
            this.getProfessorsOptions();
        }
    }

    getProfessorsOptions = () => {
        axios.post('employees/by-key/professor', {})
            .then(response => {
                const professorOptions = response.data.map(professor => ({
                    ...professor,
                    key: professor.id,
                    text: `${professor.firstName} ${professor.lastName}`,
                    value: professor.id
                }));
                this.setState({ professorOptions });
            })
            .catch(error => {
                toast('Došlo je do greške prilikom učitavanja profesora.');
            });
    };

    getSemestersOptions = () => {
        axios.get(`/semester/by-academic-year/${this.state.academicYear}`)
            .then((response) => {
                const semesterOptions = response.data
                    .filter((semester) => semester.name && (semester.name.id === 1 || semester.name.id === 2))
                    .map((semester) => ({
                        ...semester,
                        key: semester.id,
                        text: semester.name.name,
                        value: semester.id
                    }));
                this.setState({ semesterOptions });
            })
            .catch(error => {
                toast('Došlo je do greške prilikom učitavanja semestara.');
            });
    };

    getCourseImplementationSemester = (semesterId) => {
        const sem = (this.state.semesterOptions || []).find(s => s.id === semesterId);
        return sem && sem.name && sem.name.id ? sem.name.id : null;
    };

    getCourseOptions = () => {
        if (!this.state.professor || !this.state.semesters || this.state.semesters.length === 0) {
            this.setState({ courseOptions: [] });
            return;
        }
        axios.post(`/course/implementations-by-semesters-and-staff/${this.state.professor}`, [...this.state.semesters])
            .then((response) => {
                const courseOptions = response.data.map((course) => ({
                    key: course.courseImplementationId,
                    text: course.courseImplementationName,
                    value: course.courseImplementationId,
                    description: course.comment,
                    icon: this.getCourseImplementationSemester(course.semesterId) === 1 ? {
                        name: 'snowflake',
                        color: 'blue'
                    } : {
                        name: 'sun',
                        color: 'yellow'
                    }
                }));
                courseOptions.sort((a, b) => a.text.localeCompare(b.text));
                this.setState({ courseOptions });
            })
            .catch(error => {
                toast('Došlo je do greške prilikom učitavanja predmeta.');
            });
    };

    fetchExams = () => {
        this.setState({ loadingExams: true });
        if (!this.state.courses || this.state.courses.length === 0) {
            this.setState({
                exams: [],
                loadingExams: false
            });
            return;
        }
        axios.post(`/exams/by-course-implementations/${this.state.professor}`, [...this.state.courses])
            .then((response) => {
                this.setState({
                    exams: response.data,
                    filteredExams: response.data,
                    loadingExams: false
                }, () => this.handleSelectAll(true));
            })
            .catch((error) => {
                toast('Došlo je do greške prilikom učitavanja ispita.');
                this.setState({
                    exams: [],
                    loadingExams: false
                });
            });
    };

    archive = (id, optLock) => {
        let obj = {
            id,
            optLock
        };
        this.setState({ loadingExams: true });
        axios.put('/exams/archive', { ...obj })
            .then(res => {
                toast('Uspješno ste arhivirali ispit.');
                this.fetchExams();
            })
            .catch(err => {
                toast('Došlo je do greške! Arhiviranje ispita nije uspjelo.');
                this.setState({ loadingExams: false });
            });
    };

    handleSelectAll = (checked) => {
        if (checked) {
            this.setState({
                selectedExams: this.state.filteredExams.map(el => el.gradedActivityId)
            });
        } else {
            this.setState({ selectedExams: [] });
        }
    };

    handleRowSelect = (gradedActivityId, checked) => {
        const selectedExams = [...this.state.selectedExams];
        if (checked) {
            if (!selectedExams.includes(gradedActivityId)) {
                selectedExams.push(gradedActivityId);
            }
        } else {
            const index = selectedExams.indexOf(gradedActivityId);
            if (index > -1) {
                selectedExams.splice(index, 1);
            }
        }
        this.setState({ selectedExams });
    };

    handleInputChange = (e, {
        name,
        value
    }) => {
        this.setState({ [name]: value }, () => {
            if (name === 'academicYear') {
                this.setState({
                    semesters: [],
                    courseOptions: [],
                    courses: [],
                    exams: []
                }, () => this.getSemestersOptions());
            }
            if (name === 'semesters' || name === 'professor') {
                this.setState({
                    courses: [],
                    courseOptions: [],
                    exams: []
                }, () => this.getCourseOptions());
            }
            if (name === 'courses') {
                this.setState({ exams: [] }, () => this.fetchExams());
            }
        });
    };

    saveFiltersToLocalStorage = () => {
        localStorage.setItem('examApplicationsByProfessorFilters', JSON.stringify({
            semesterOptions: this.state.semesterOptions,
            professorOptions: this.state.professorOptions,
            courseOptions: this.state.courseOptions,
            academicYear: this.state.academicYear,
            semesters: this.state.semesters,
            professor: this.state.professor,
            courses: this.state.courses
        }));
    };

    printExamAppByGradedActivities() {
        const gradedActivityIds = this.state.exams
            .filter(el => this.state.selectedExams.includes(el.gradedActivityId))
            .map(el => el.gradedActivityId);

        let obj = {
            language: this.state.language || 'ba',
            orientation: this.state.orientation || 'horizontal',
            gradedActivityIds,
            employeeId: this.state.professor,
        };


        this.setState({ loadingPrint: true });
        axios({
            method: 'post',
            url: '/documents/exam-application/graded-activities',
            responseType: 'blob',
            data: obj
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                this.setState({ loadingPrint: false });
            })
            .catch(err => {
                toast('Došlo je do greške! Štampanje nije izvršeno.');
                this.setState({ loadingPrint: false });
            });
    }

    filterExams() {
        let filteredExams = this.state.exams;
        if (this.state.dateFrom) {
            filteredExams = filteredExams.filter(exam => moment(exam.gradedActivityDate)
                .isSameOrAfter(moment(this.state.dateFrom)
                    .startOf('day')));
        }
        if (this.state.dateTo) {
            filteredExams = filteredExams.filter(exam => moment(exam.gradedActivityDate)
                .isSameOrBefore(moment(this.state.dateTo)
                    .startOf('day')));
        }

        this.setState({
            filteredExams,
        }, () => this.handleSelectAll(true));
    }

    render() {
        return <div>
            <Form>
                <Form.Group widths={'equal'}>
                    <Form.Field>
                        <label>Akademska godina</label>
                        <Form.Dropdown clearable
                                       placeholder="Odaberite akademsku godinu"
                                       options={this.props.academicYears}
                                       value={this.state.academicYear}
                                       onChange={this.handleInputChange}
                                       name="academicYear"
                                       search
                                       fluid
                                       selection
                                       icon
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Semestar</label>
                        <Form.Dropdown clearable
                                       placeholder="Odaberite semestar"
                                       name="semesters"
                                       options={this.state.semesterOptions}
                                       value={this.state.semesters}
                                       onChange={this.handleInputChange}
                                       disabled={this.state.semesterOptions.length === 0}
                                       search
                                       fluid
                                       selection
                                       icon
                                       multiple
                        />
                    </Form.Field>
                </Form.Group>
                <Form.Group widths={'equal'}>
                    <Form.Field>
                        <label>Profesor</label>
                        <Form.Dropdown clearable
                                       placeholder="Odaberite profesora"
                                       name="professor"
                                       options={this.state.professorOptions}
                                       value={this.state.professor}
                                       onChange={this.handleInputChange}
                                       disabled={this.state.professorOptions.length === 0}
                                       search
                                       fluid
                                       selection
                                       icon
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Predmet</label>
                        <Form.Dropdown clearable
                                       placeholder="Odaberite predmet"
                                       name="courses"
                                       disabled={this.state.courseOptions.length === 0}
                                       options={this.state.courseOptions}
                                       value={this.state.courses}
                                       onChange={this.handleInputChange}
                                       search
                                       fluid
                                       selection
                                       icon
                                       multiple
                        />
                    </Form.Field>
                </Form.Group>
                {this.state.exams.length > 0
                    && <Form.Group widths={'equal'}>
                        <Form.Field>
                            <label>Od</label>
                            <FormattedMessage id="poll.placeholderDate">
                                {msg => (
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        time={false}
                                        placeholder={msg}
                                        value={this.state.dateFrom ? new Date(this.state.dateFrom) : null}
                                        onChange={(value) => {
                                            this.setState({ dateFrom: value }, this.filterExams);
                                        }}
                                    />
                                )}
                            </FormattedMessage>
                        </Form.Field>
                        <Form.Field>
                            <label>Do</label>
                            <FormattedMessage id="poll.placeholderDate">
                                {msg => (
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        time={false}
                                        placeholder={msg}
                                        value={this.state.dateTo ? new Date(this.state.dateTo) : null}
                                        onChange={(value) => {
                                            this.setState({ dateTo: value }, this.filterExams);
                                        }}
                                    />
                                )}
                            </FormattedMessage>
                        </Form.Field>
                    </Form.Group>
                }
                <Form.Group widths={'equal'}>
                    <Form.Field required>
                        <label>Jezik</label>
                        <Form.Dropdown
                            selection
                            placeholder="Odaberite jezik"
                            value={this.state.language}
                            onChange={this.handleInputChange}
                            name="language"
                            options={this.state.languages}
                            search
                            fluid
                        />
                    </Form.Field>
                    <Form.Field required>
                        <label>Orijentacija</label>
                        <Form.Dropdown
                            selection
                            placeholder="Odaberite orijentaciju"
                            value={this.state.orientation}
                            onChange={this.handleInputChange}
                            name="orientation"
                            options={this.state.orientations}
                            fluid
                        />
                    </Form.Field>
                </Form.Group>
            </Form>
            {this.state.loadingExams ? (<div style={{
                    paddingTop: '100px',
                    paddingBottom: '100px'
                }}><Loader active inline="centered"/></div>) :
                (this.state.courses && this.state.courses.length > 0) && <Table celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width="1" textAlign="center">
                                <Form.Checkbox
                                    checked={this.state.filteredExams.length > 0 && this.state.selectedExams.length === this.state.filteredExams.length}
                                    indeterminate={this.state.selectedExams.length > 0 && this.state.selectedExams.length < this.state.filteredExams.length}
                                    onChange={(_, { checked }) => this.handleSelectAll(checked)}
                                />
                            </Table.HeaderCell>
                            <Table.HeaderCell width="1">R.br.</Table.HeaderCell>
                            <Table.HeaderCell colSpan="2">Predmet</Table.HeaderCell>
                            <Table.HeaderCell>Tip ispita</Table.HeaderCell>
                            <Table.HeaderCell>Datum i vrijeme ispita</Table.HeaderCell>
                            <Table.HeaderCell>Napomena</Table.HeaderCell>
                            <Table.HeaderCell>Datum ponovnog otvaranja ispita (odluka)</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" textAlign="center">
                                <Button
                                    disabled={this.state.selectedExams.length === 0 || this.state.loadingPrint}
                                    icon
                                    labelPosition="left"
                                    primary
                                    loading={this.state.loadingPrint}
                                    onClick={() => {
                                        this.printExamAppByGradedActivities();
                                    }}
                                >
                                    <Icon className="print"/> Štampanje
                                </Button>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.filteredExams.length > 0 ? this.state.filteredExams.map((el, index) =>
                                (<Table.Row key={el.gradedActivityId} positive={el.archived} negative={!el.archived}>
                                    <Table.Cell width="1" textAlign="center" verticalAlign="middle">
                                        <Form.Checkbox
                                            checked={this.state.selectedExams.includes(el.gradedActivityId)}
                                            onChange={(_, { checked }) => this.handleRowSelect(el.gradedActivityId, checked)}
                                        />
                                    </Table.Cell>
                                    <Table.Cell width="1" verticalAlign="middle">
                                        {index + 1}.
                                    </Table.Cell>
                                    <Popup
                                        content={el.semesterNameKey === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                                        hideOnScroll
                                        position="left center"
                                        trigger={<Table.Cell verticalAlign="middle" colSpan="2">
                                            <Grid columns={1} centered className="stackable">
                                                <Grid.Row verticalAlign="middle">
                                                    <Grid.Column width="10">
                                                <span>  {el.semesterNameKey === 'winter semester' ?
                                                    <Icon name="snowflake" color="blue"/> : <Icon name="sun"
                                                                                                  color="yellow"/>}{el.courseImplementationName}</span>
                                                    </Grid.Column>
                                                    <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                        <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </Table.Cell>}
                                    />
                                    <Table.Cell verticalAlign="middle">
                                        {el.gradedActivityName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {moment(el.gradedActivityDate)
                                            .format('D. M. YYYY. - HH:mm')}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.comment}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.finalizationCancelDate ? moment(el.finalizationCancelDate)
                                            .format('D. M. YYYY.') + '\n' : ''}
                                        {el.documentNumber ? ' ( Odluka: ' + el.documentNumber + ')' : ''}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                        {this.state.inputDocNum === false
                                            && <Link to={{
                                                pathname: '/ispitni-rokovi/ispiti/detalji',
                                            }}
                                            >
                                                <Popup
                                                    content="Detalji"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="align justify"
                                                            size="small"
                                                            color="blue"
                                                            onClick={() => {
                                                                this.saveFiltersToLocalStorage();
                                                                localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                                localStorage.setItem('courseImplementationName', el.courseImplementationName ? el.courseImplementationName : '');
                                                                localStorage.setItem('gradedActivityName', el.gradedActivityName ? el.gradedActivityName : '');
                                                                localStorage.setItem('gradedActivityDate', el.gradedActivityDate ? el.gradedActivityDate : '');
                                                                localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                                localStorage.setItem('classroom', el.classroom ? el.classroom : '');
                                                                localStorage.setItem('comment', el.comment ? el.comment : '');
                                                                localStorage.setItem('gradingMethodId', el.gradingMethodId ? el.gradingMethodId : '');
                                                                localStorage.setItem('gradedActivityTypeId', el.gradedActivityTypeId);
                                                                localStorage.setItem('gradedActivityRegistrationDateStart', el.gradedActivityRegistrationDateStart ? el.gradedActivityRegistrationDateStart : '');
                                                                localStorage.setItem('gradedActivityRegistrationDateEnd', el.gradedActivityRegistrationDateEnd ? el.gradedActivityRegistrationDateEnd : '');
                                                                localStorage.setItem('optLock', el.optLock);
                                                                localStorage.setItem('gradedActivityRegistrationClosing', el.gradedActivityRegistrationClosing ? el.gradedActivityRegistrationClosing : '');
                                                                localStorage.setItem('grades', true);
                                                                localStorage.setItem('finalized', true);
                                                                localStorage.setItem('courseComment', el.courseComment);
                                                            }}
                                                        />}
                                                />
                                            </Link>}
                                        {this.state.inputDocNum === false && <Link to={{
                                            pathname: '/ispitni-rokovi/ispiti/prijave-za-ispite',
                                            state: {
                                                gradedActivityId: el.gradedActivityId,
                                                gradedActivityName: el.gradedActivityName,
                                                courseImplementationName: el.courseImplementationName
                                            }
                                        }}
                                        >
                                            {(localStorage.getItem('activeRole')
                                                .substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Popup
                                                content="Prijave"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="copy outline"
                                                        size="medium"
                                                        color="teal"
                                                        onClick={() => {
                                                            this.saveFiltersToLocalStorage();
                                                            localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                            localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                            localStorage.setItem('courseImplementationName', el.courseImplementationName ? el.courseImplementationName : '');
                                                            localStorage.setItem('gradedActivityName', el.gradedActivityName ? el.gradedActivityName : '');
                                                            localStorage.setItem('gradedActivityDate', el.gradedActivityDate ? el.gradedActivityDate : '');
                                                            localStorage.setItem('courseComment', el.courseComment);
                                                        }}
                                                    />}
                                            />}
                                        </Link>}

                                        {(this.state.inputDocNum === false && !el.archived && (localStorage.getItem('activeRole')
                                            .substr(0, 38) !== 'Služba za nastavu i studentska pitanja')) ? <Popup
                                            trigger={<Icon
                                                name="checkmark"
                                                color="green"
                                                style={{
                                                    cursor: 'pointer',
                                                    float: 'right'
                                                }}
                                                onClick={() => {
                                                    el.archived !== true && this.archive(el.gradedActivityId, el.optLock);
                                                }}
                                            />}
                                            content="Arhiviranje ispita nakon završenog printanja prijava."
                                        /> : <Icon/>
                                        }
                                    </Table.Cell>
                                </Table.Row>))
                            : <Table.Row>
                                <Table.Cell colSpan="9" textAlign="left">
                                    Nema finaliziranih ispita za prikaz.
                                </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>}
            <ToastContainer position="top-right" hideProgressBar={true}/>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamApplications/ExamApplicationsByProfessor.js